"use client";

import { init } from "@amplitude/analytics-browser";
import { useEffect } from "react";
import { ensureSurfacePlugin } from "@/lib/amplitude/surface-plugin";

const AMPLITUDE_API_KEY = process.env.NEXT_PUBLIC_AMPLITUDE_API_KEY;

export default function AuthInitPage() {
  useEffect(() => {
    const run = async () => {
      if (AMPLITUDE_API_KEY) {
        await init(AMPLITUDE_API_KEY, undefined, {
          // This page mounts only to write the device_id cookie and
          // immediately navigates away — sessions/pageViews/formInteractions/
          // fileDownloads stay off so it doesn't emit its own bogus events.
          // attribution stays ON: it's the SDK's Attribution plugin that
          // turns campaign params (utm_*, gclid, ...) — forwarded here by
          // middleware's /signup redirect — into the initial_utm_* /
          // initial_referrer user properties a cold signup needs. Fires
          // automatically as part of init(), no explicit track() call needed.
          defaultTracking: {
            attribution: true,
            sessions: false,
            pageViews: false,
            formInteractions: false,
            fileDownloads: false
          },
          cookieOptions: { domain: ".getshield.xyz" }
        }).promise;

        // The attribution event this init() fires is the first event of a cold
        // signup — it needs the surface too, or the funnel's entry point is the
        // one event without it.
        ensureSurfacePlugin();
      }

      // Forward whatever this hop was called with (screen_hint, product,
      // invite, login_hint, ref — see middleware's /signup and no-session
      // redirects) straight through to Auth0. This page's only job is
      // making sure the Amplitude device_id cookie exists first.
      window.location.href = `/api/auth/login${window.location.search}`;
    };

    run();
  }, []);

  return null;
}
